import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/public.css'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import mixins from './mixins'
import vueAxios from 'vue-axios'
import consts from './const'

window.consts = consts


Number.prototype.hpToFixed = function () {
    let num = this
    let newNum = num
    let arr = num.toString().split('.')
    let zhengshu = arr[0]
    if (arr[1] && arr[1].length > 2) { //如果有小数切小数位数大于2位
        let xiaoshu = arr[1]
        newNum = Number(zhengshu + '.' + xiaoshu.substr(0, 2))
        if (Number(xiaoshu[2]) >= 5) {
            newNum = newNum * 100 +1
            newNum = newNum /100
        }
    }
    return newNum
}

Vue.use(vueAxios, axios)
axios.defaults.baseURL = 'https://easy-mock.com/mock/5cb1fedee1383c29e74b6044/aoshang/'
axios.defaults.baseURL = 'http://211.149.182.192:85'
window.baseUrl = 'http://211.149.182.192:85'
// axios.defaults.baseURL = 'http://www.aoshang.com.au/'
// window.baseUrl = 'http://www.aoshang.com.au/'
if (process.env.NODE_ENV === 'production') {
    axios.defaults.baseURL = ''
    window.baseUrl = window.location.protocol + "//" + window.location.host
}

/*let _token = localStorage.getItem('as_user_token')
if (_token) {// 这中方式登陆后replace路由就获取不到token
    axios.defaults.headers.common['Authorization'] = 'bearer ' + _token
}*/
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
    let key = window.location.pathname.indexOf('admin') > 0 ? window.consts.strings.adminToken : window.consts.strings.userToken;
    //console.log(key)
    // 在发送请求之前做些什么
    config.headers['.AspNetCore.Culture'] = 'c=zh-Hans|uic=zh-Hans'
    let _token = localStorage.getItem(key)
    if (!config.headers['Authorization'] && _token) {
        config.headers['Authorization'] = 'bearer ' + _token
    }
    return config
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
})

axios.interceptors.response.use(function (response) {
    return response.data
}, function (error) {
    // console.log(error.toString().indexOf('403'))
    // if(response.data.success === false && response.data.error.message.indexOf('您没有权限')){
    
    /*if (error.response) {
        console.log(error.response.status);
        // 如果token无效就清除重新登录
        switch (error.response.status) {
            case 401:
                //console.log(router.currentRoute.fullPath)
                localStorage.removeItem(window.consts.strings.userToken)
                // 返回 401 清除token信息并跳转到登录页面
                let login = '/login'
                if (router.currentRoute.path.indexOf("/m/") >= 0) {
                    login = '/m/login'
                }
                router.replace({
                    path: login,
                    query: { returnUrl: router.currentRoute.fullPath}
                })
        }
    }*/
    if (error.response && (error.response.status == 401 || error.response.status == 403)) {
        localStorage.removeItem(window.consts.strings.userToken)
        // 返回 401 清除token信息并跳转到登录页面
        let login = '/login'
        if (browserRedirect()) {
            login = '/m/login'
        }
        /*if (router.currentRoute.path.indexOf("/m/") >= 0) {
            login = '/m/login'
        }*/
        router.replace({
            path: login,
            query: { returnUrl: router.currentRoute.fullPath}
        })
    }
    
    // 前端如果未登录或登录信息失效就去登录
    if (error.toString().indexOf('403') > 0 || error.toString().indexOf('401') > 0) {
        //window.location.href = '/login';
    }
    
    
    return Promise.reject(error)
})
Vue.prototype.$axios = axios

// Vue.prototype.$axios = axios    //全局注册，使用方法为:this.$axios
// https://segmentfault.com/a/1190000013128858?utm_source=tag-newest  vue全局使用axios的方法
// https://github.com/axios/axios
// https://www.cnblogs.com/libin-1/p/6607945.html 全攻略

//import Vant from 'vant';
import 'vant/lib/index.css';
//Vue.use(Vant);

Vue.use(ElementUI)
Vue.mixin(mixins)
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

function browserRedirect() {
    var isPhone = false;
    var sUserAgent = navigator.userAgent.toLowerCase();
    var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    var bIsMidp = sUserAgent.match(/midp/i) == "midp";
    var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    var bIsAndroid = sUserAgent.match(/android/i) == "android";
    var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        isPhone = true;
    }
    return isPhone;
}
